import httpClientTelemetric from "./http-client";

class StationDataService {
  async getRegionalStationData(id) {
    const httpClient = new httpClientTelemetric();
    const api = await httpClient.configureTelemetric();
    return api.get(`/alertadisdata?regionalIds=${id}`);
  }
  async getAgencieStationData(id) {
    const httpClient = new httpClientTelemetric();
    const api = await httpClient.configureTelemetric();
    return api.get(`/alertadisdata?agencyIds=${id}`);
  }
  async getCountieStationData(id) {
    const httpClient = new httpClientTelemetric();
    const api = await httpClient.configureTelemetric();
    return api.get(`/alertadisdata?cityIds=${id}`);
  }
}

export default new StationDataService();
